function generateRandomLocation(length: number): string {
  const characters: string = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let randomString: string = '';
  for (let i = 0; i < length; i++) {
    const randomIndex: number = Math.floor(Math.random() * characters.length);
    randomString += characters.charAt(randomIndex);
  }
  return randomString;
}

export const generateCsv = (r: number) => {
  const rows = [];
  const header = ['location_ID'];
  rows.push(header);
  for (let i = 0; i < r; i++) {
    const row = [generateRandomLocation(24)];
    rows.push(row);
  }
  return rows.join('\n');
};
